<p-sidebar class="real-estate-search-sidebar" [(visible)]="isVisible" [fullScreen]="true" [showCloseIcon]="false" position="right" [blockScroll]="true" (onHide)="close()">
  <ng-template pTemplate="content">
    <div class="search-input-sidebar-container">
      <div class="search-wrapper">
        <div class="input-wrapper" [class.active]="query.length">
          <button type="button" class="clear-button left" aria-label="Volver" (click)="close()"><i class="pi pi-arrow-left"></i></button>
          <input
            #searchInput
            type="text"
            autocomplete="off"
            placeholder="Busca una ubicación"
            aria-label="Ubicación"
            role="combobox"
            aria-autocomplete="list"
            aria-controls="real-estate-sidebar-suggestions"
            [attr.aria-expanded]="openSuggestions"
            [attr.aria-activedescendant]="openSuggestions && activeIndex >= 0 ? 'real-estate-sidebar-option-' + activeIndex : null"
            [value]="query"
            (input)="onInput($event)"
            (focus)="onFocus()"
            (keydown)="onKeydown($event)" />
          @if (query.length) {
            <button type="button" class="clear-button right" aria-label="Borrar ubicación" (click)="clearQuery()"><i class="icon-cancel-fill"></i></button>
          }
        </div>
        <button type="button" class="search-button" aria-label="Buscar ubicación" [disabled]="!selectedSuggestion" (click)="search()"><i class="icon-search icon"></i></button>
      </div>
    </div>
    @if (openSuggestions) {
      @if (suggestions.length) {
        <div class="suggestion-list-container">
          <p class="suggestion-heading">Ubicaciones sugeridas</p>
          <ul id="real-estate-sidebar-suggestions" class="suggestion-list" role="listbox" aria-label="Ubicaciones sugeridas">
            @for (suggestion of suggestions; track suggestion.label; let index = $index) {
              <li
                [id]="'real-estate-sidebar-option-' + index"
                role="option"
                [attr.aria-selected]="index === activeIndex"
                [class.active]="index === activeIndex"
                (mousedown)="$event.preventDefault()"
                (click)="select(suggestion)">
                <i class="icon-search" aria-hidden="true"></i>
                {{ suggestion.label }}
              </li>
            }
          </ul>
        </div>
      } @else {
        <p id="real-estate-sidebar-suggestions" class="empty-results" role="status">No encontramos resultados para tu búsqueda.</p>
      }
    }
  </ng-template>
</p-sidebar>
